export default {
  resource:{
    zh: {
      title:"充值",
      companyNo: "公司编号",
      companyName: "公司名称",
      empId:"工号",
      empName:"姓名",
      deptName:"部门",
      job:"岗位",
      duty:"职务",
      amount:"充值前余额",
      amountn:"当前余额",
      expand:"充值金额",
      balance:"充值后余额",
      rcType:"充值类型",
      rcType1:"预支充值",
      rcType2:"现金充值",
      rcType3:"支付宝充值",
      rcType4:"微信充值",
      rcType5:"网银充值",
      rcBy:"经办",
      money:"金额",
      rcDate:"充值时间",
      rcMonth:"月累计充值",
      xdate1:	"开始日期",
      xdate2:	"结束日期",
      remark:	"备注",
      recharge:"充值",
      nullDept:"请先选择部门！",
      nullGn:"请先添加员工！",
      emoney:"请先输入正确的金额！",
      rAll:"是否确定为所有人充值",
      rAll1:"是否确定为所有人充值到",
      notFound:"找不到记录，请检查输入的数据是否正确！",
      deptNo: "部门",
      deptName: "部门",
      xgroup:"组别",
      job:"岗位"
    }
  },
  params: {
    xdate1:{
      key: "rcDate",
      tkey: "xdate1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    xdate2:{
      key: "rcDate",
      tkey: "xdate2",
      data: null,
      method: "DateTimeLessThanOrEqual",
      type: "date"
    },
    deptNo:{
      key: "deptNo",
      data: "",
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }]
    },
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      type: "number"
    },
    empName:{
      key: "empName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "deptName", "xgroup","job","empId","empName","expand","balance", {key:"rcDate", formatter:"fdateTime", width:180},
    {key:"rcType", formatter:"frcType"}, "rcBy", "remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"rcDate",
  defaultSortOrder:"desc",
  sortName: "rcDate",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "rechargeRecord/",
  autoId: "autoid",
  formatter:{
    frcType(v){
      if (v) return "rcType"+v
    }
  }

}
